import { routes } from '@/core/routing/routes/routes.gb';
import { createURL } from '@/core/routing/URLParser';
import { ProductCardData } from '@/productDiscovery/productCards/interfaces/productCardData';

export const createProductUrl = (
  product: ProductCardData,
  forceLinkToOffer: boolean = false,
) => {
  if (product.sponsoredData || forceLinkToOffer) {
    return createURL(
      routes.product,
      {
        slug: product.slug,
        id: product.articleId,
      },
      { product_id: product.productId },
    );
  }
  if (product.variantsCount > 1) {
    return createURL(
      routes.product,
      {
        slug: product.slug,
        id: product.articleId,
      },
      { model_id: product.modelId },
    );
  }
  return createURL(routes.product, {
    slug: product.slug,
    id: product.articleId,
  });
};
